import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-event",
  "use": "icon-s-event-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-s-event\">\n<path d=\"M19 20H3V10.48H19V20ZM10.1188 14.0022L7.83021 14.1892L9.57292 15.7128L9.04063 17.9908L11 16.77L12.9594 17.9908L12.4271 15.7128L14.1698 14.1892L11.8813 14.0022L11 11.84L10.1188 14.0022Z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#314455\" />\n<path d=\"M7.66667 5.04H14.3333V3H15.6667V5.04H19V9.12H3V5.04H6.33333V3H7.66667V5.04Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/s-event.svg
// module id = du8S
// module chunks = 258